(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // customElements.whenDefined('details-disclosure').then(() => {
  //   class NavMenu extends DetailsDisclosure {
  //     constructor() {
  //       super();


  //       if(this.matches('.js-mega-nav')) {
  //         this.reset(false);
  //         window.addEventListener('on:breakpoint-change', this.reset.bind(this));
  //       }
  //     }


  //     reset(resize = true) {
  //       const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
  //       this.disclosure.open = isLargeScreen;
  //       if (isLargeScreen) {
  //         this.toggle.setAttribute('tabindex', '-1');
  //       } else {
  //         this.toggle.removeAttribute('tabindex');
  //       }
  //     }


  //     handleToggle(e) {
  //       if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
  //         super.handleToggle(e);
  //       }
  //     }
  //   }


  //   customElements.define('nav-menu', NavMenu);
  // });


  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();


        this.breakpointQuery = window.matchMedia('(max-width: 1063px)');


        if (this.matches('.js-mega-nav')) {
          this.reset(); // initialize state
          this.breakpointQuery.addEventListener('change', this.reset.bind(this)); // on resize
        }
      }


      reset() {
        const isMobile = this.breakpointQuery.matches;


        this.disclosure.open = !isMobile;


        if (!isMobile) {
          this.toggle.setAttribute('tabindex', '-1'); // remove from tab order
        } else {
          this.toggle.removeAttribute('tabindex'); // allow tabbing on mobile
        }
      }


      handleToggle(e) {
        const isMobile = this.breakpointQuery.matches;


        if (!(this.matches('.js-mega-nav') && !isMobile)) {
          super.handleToggle(e); // only toggle in mobile or if not mega-nav
        }
      }
    }


    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-size-guide-link"] && !Shopify.designMode) return;
  try {
    
function formatGuideMeasurement(value, unit, type = '') {
  const raw = String(value ?? '').trim();
  if (type === 'text') return raw || '—';
  const match = raw.match(/^(\d+(?:\.\d+)?)\s*(?:cm)?\s*(?:[-–—]\s*(\d+(?:\.\d+)?)\s*(?:cm)?)?$/i);
  if (!match) return raw || '—';
  const convert = number => unit === 'in' ? String(Math.round(Number(number) / 2.54 * 100) / 100) : number;
  return `${convert(match[1])}${match[2] ? `–${convert(match[2])}` : ''} ${unit === 'in' ? 'in' : 'cm'}`;
}
if (!customElements.get('dharco-guide-preview')) {
  customElements.define('dharco-guide-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.entries = new Map();
      this.picker = this.querySelector('[data-picker]');
      this.status = this.querySelector('[data-status]');
      this.openButton = this.querySelector('[data-open]');
      this.modal = this.querySelector('dialog');
      this.content = this.querySelector('[data-content]');
      this.picker.addEventListener('change', () => this.selectGuide());
      this.openButton.addEventListener('click', () => this.modal.showModal());
      this.querySelector('[data-close]').addEventListener('click', () => this.modal.close());
      this.modal.addEventListener('click', event => { if (event.target === this.modal) this.modal.close(); });
      this.modal.addEventListener('close', () => this.openButton.focus());
      this.querySelector('[data-retry]').addEventListener('click', () => this.loadGuides());
      this.content.addEventListener('click', event => {
        const toggle = event.target.closest('.test-guide__units');
        if (!toggle) return;
        const active = toggle.querySelector('[data-guide-unit][aria-pressed="true"]');
        this.setUnit(active?.dataset.guideUnit === 'in' ? 'cm' : 'in');
      });
      this.loadGuides();
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.modal?.open) this.modal.close();
      this.initialized = false;
    }
    async loadGuides() {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.picker.disabled = true;
      this.openButton.disabled = true;
      this.querySelector('[data-retry]').hidden = true;
      this.status.textContent = 'Loading all available guides…';
      this.entries.clear();
      try {
        const base = new URL(window.location.href);
        base.searchParams.delete('sections');
        base.searchParams.set('section_id', this.dataset.sectionId);
        base.searchParams.set('page', '1');
        let url = base;
        const visited = new Set();
        let total = 0;
        while (url) {
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Unexpected pagination link.');
          visited.add(url.href);
          const response = await fetch(url.href, { signal: controller.signal });
          if (!response.ok) throw new Error(`Shopify returned ${response.status}.`);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const root = [...doc.querySelectorAll('dharco-guide-preview')].find(item => item.dataset.sectionId === this.dataset.sectionId);
          const pagination = root?.querySelector('[data-pagination]');
          if (!pagination) throw new Error('Shopify did not return the guide section.');
          total = Number(pagination.dataset.total);
          root.querySelectorAll('template[data-guide-entry]').forEach(entry => this.entries.set(entry.dataset.handle, entry));
          this.status.textContent = `Loading guides: ${this.entries.size} of ${total}…`;
          if (pagination.dataset.next) {
            const next = new URL(pagination.dataset.next, url);
            // Preserve preview_theme_id, locale, and alternate-template parameters.
            url = new URL(base);
            next.searchParams.forEach((value, key) => url.searchParams.set(key, value));
            url.searchParams.set('section_id', this.dataset.sectionId);
          } else url = null;
        }
        if (this.entries.size !== total) throw new Error(`Loaded ${this.entries.size} of ${total}; the list is incomplete.`);
        this.picker.replaceChildren(new Option('Choose a guide', ''));
        [...this.entries.values()].sort((a, b) => a.dataset.label.localeCompare(b.dataset.label)).forEach(entry => {
          this.picker.add(new Option(`${entry.dataset.label} — ${entry.dataset.handle}${entry.dataset.chart === 'no' ? ' (no chart)' : ''}`, entry.dataset.handle));
        });
        this.picker.disabled = total === 0;
        this.status.textContent = total ? `${total} guides loaded. Choose a guide to preview.` : 'No storefront-accessible Product Data entries found. Check metaobject storefront access and entry status.';
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.status.textContent = `Could not load the complete guide list. ${error.message}`;
        this.querySelector('[data-retry]').hidden = false;
      }
    }
    setUnit(unit) {
      this.content.querySelectorAll('[data-guide-unit]').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.guideUnit === unit)));
      this.content.querySelectorAll('[data-cm]').forEach(cell => {
        cell.textContent = formatGuideMeasurement(cell.dataset.cm, unit, cell.dataset.columnType);
      });
      this.content.querySelectorAll('[data-guide-column-label]').forEach(heading => {
        const label = heading.dataset.guideColumnLabel;
        // Change only a trailing column unit, not measurement instructions such as "18CM UP FROM KNEE".
        heading.textContent = heading.dataset.columnType === 'text' ? label : label.replace(/\s*\(cm\)\s*$|\s+cm\s*$/i, unit === 'in' ? ' (IN)' : ' (CM)');
      });
    }
    formatNotices() {
      this.content.querySelectorAll('.test-guide__notice .rte').forEach(rte => {
        const container = rte.querySelector('.metafield-rich_text_field') || rte;
        const first = container.firstElementChild;
        if (!first) return;
        // Split at the first explicit line break, never at a visual wrapping line.
        const walker = document.createTreeWalker(first, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
        let node, boundary;
        while ((node = walker.nextNode())) {
          if (node.nodeType === 1 && node.tagName === 'BR') { boundary = { node }; break; }
          if (node.nodeType === 3 && /\S/.test(node.textContent.split('\n')[0]) && node.textContent.includes('\n')) {
            boundary = { node, offset: node.textContent.indexOf('\n') }; break;
          }
        }
        if (boundary) {
          const range = document.createRange();
          range.setStart(first, 0);
          if (boundary.offset !== undefined) range.setEnd(boundary.node, boundary.offset);
          else range.setEndBefore(boundary.node);
          const title = document.createElement('div');
          title.className = 'test-guide__notice-title';
          title.append(range.extractContents());
          if (boundary.offset === undefined) boundary.node.remove();
          else boundary.node.textContent = boundary.node.textContent.replace(/^\n/, '');
          container.insertBefore(title, first);
        } else if (first.nextElementSibling || /^H[1-6]$/.test(first.tagName)) {
          first.classList.add('test-guide__notice-title');
        }
      });
    }
    selectGuide() {
      const entry = this.entries.get(this.picker.value);
      this.content.replaceChildren();
      this.openButton.disabled = !entry;
      if (!entry) { this.status.textContent = `${this.entries.size} guides loaded. Choose a guide to preview.`; return; }
      // Import into the active document so lazy images and other nodes are adopted correctly.
      this.content.append(document.importNode(entry.content, true));
      this.setUnit('cm');
      this.formatNotices();
      if (!this.content.querySelector('[data-test-guide]')) {
        const message = document.createElement('p');
        message.className = 'test-guide';
        message.textContent = 'The size-guide content did not render. Check that snippets/test-size-guide-modal-content.liquid contains the latest supplied renderer.';
        this.content.append(message);
      }
      this.querySelector('[data-title]').textContent = 'SIZE GUIDE';
      this.content.scrollTop = 0;
      this.status.textContent = `${this.entries.size} guides loaded. Selected: ${entry.dataset.handle}.${entry.dataset.chart === 'no' ? ' No chart rows in this record.' : ''}${entry.dataset.jsonSteps === 'yes' ? ' This record contains how_to_measure_data JSON; the supplied renderer displays the legacy how_to_measure_1/2/3 fields only.' : ''}`;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
